import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-five',
  templateUrl: './blog-five.component.html',
  styleUrls: ['./blog-five.component.scss']
})
export class BlogFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
